<style scoped>
.v-list__tile__action {
  justify-content: center;
}
</style>

<template>
  <v-list>
    <v-list-tile @click="$emit('click')">
      <v-list-tile-action>
        <v-icon>{{ icon }}</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>{{ title }}</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
  </v-list>
</template>

<script>
export default {
  props: ["title", "icon"]
};
</script>
